import { useSyncExternalStore } from 'react'

export type ThemePref = 'light' | 'dark' | 'system'
const KEY = 'dv.theme'

function read(): ThemePref {
  try {
    const v = localStorage.getItem(KEY)
    if (v === 'light' || v === 'dark' || v === 'system') return v
  } catch {
    /* ignore */
  }
  return 'system'
}

let pref: ThemePref = read()
const listeners = new Set<() => void>()

function systemDark() {
  return typeof window !== 'undefined' && window.matchMedia?.('(prefers-color-scheme: dark)').matches
}

export function applyTheme(p: ThemePref = pref) {
  const dark = p === 'dark' || (p === 'system' && systemDark())
  document.documentElement.classList.toggle('dark', !!dark)
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light'
}

export function setTheme(p: ThemePref) {
  pref = p
  try {
    localStorage.setItem(KEY, p)
  } catch {
    /* ignore */
  }
  applyTheme(p)
  listeners.forEach((f) => f())
}

export function getTheme() {
  return pref
}

export function initTheme() {
  applyTheme()
  window.matchMedia?.('(prefers-color-scheme: dark)').addEventListener?.('change', () => {
    if (pref === 'system') applyTheme()
  })
}

export function useTheme() {
  const theme = useSyncExternalStore(
    (f) => {
      listeners.add(f)
      return () => listeners.delete(f)
    },
    getTheme,
    getTheme,
  )
  return { theme, setTheme }
}
